
define('text!templates/modules/questionnaire/questions/list/question-list-item.html',[],function () { return '<div class="item-section"></div>\n';});

